import React from 'react';
import { Download } from 'lucide-react';

const CadastrosTemporarios: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <header className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Cadastros Temporarios</h1>
          <p className="text-gray-600">Acompanhe cadastros pendentes de finalizacao.</p>
        </header>

        <section className="card mb-6">
          <div className="card-body grid grid-cols-1 gap-4 md:grid-cols-4">
            <div className="md:col-span-2">
              <label className="form-label">Periodo</label>
              <div className="grid grid-cols-[1fr_auto_1fr] items-center gap-2">
                <input className="form-input" placeholder="dd/mm/aaaa" />
                <span className="text-sm text-gray-500">ate</span>
                <input className="form-input" placeholder="dd/mm/aaaa" />
              </div>
            </div>
            <div className="md:col-span-2">
              <label className="form-label">Numero da operacao</label>
              <input className="form-input" placeholder="Informe o numero da operacao" />
            </div>
            <div className="md:col-span-4 flex flex-wrap gap-3">
              <button className="btn-primary" type="button">Buscar</button>
              <button className="btn-secondary" type="button">Limpar filtros</button>
            </div>
          </div>
        </section>

        <section className="card">
          <div className="card-header flex justify-end">
            <button className="btn-secondary inline-flex items-center gap-2" type="button">
              <Download size={16} />
              Exportar Excel
            </button>
          </div>
          <div className="card-body text-center text-gray-600">
            Nenhum cadastro temporario pendente.
          </div>
        </section>
      </div>
    </div>
  );
};

export default CadastrosTemporarios;
